import { render, staticRenderFns } from "./OnlineWaMassCampaignDetails.vue?vue&type=template&id=02de61e4&scoped=true&"
import script from "./OnlineWaMassCampaignDetails.vue?vue&type=script&lang=js&"
export * from "./OnlineWaMassCampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./OnlineWaMassCampaignDetails.vue?vue&type=style&index=0&id=02de61e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02de61e4",
  null
  
)

export default component.exports